export default __webpack_public_path__ + "static/media/bandeau-1.36b4b8de.png";